<template>
  <section>
    <v-row>
      <v-col cols="12" class="mt-15">
        <v-skeleton-loader
          v-if="isLoading"
          type="table"
          class="pa-5"
          style="background: white"
        >
          <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
        </v-skeleton-loader>
        <v-data-table
          v-else
          :headers="tableHeaders"
          :items="tableData"
          show-expand
          single-expand
        >
          <template v-slot:[`item.action`]="{ item }">
            <v-btn
              small
              rounded
              color="primary"
              class="my-2"
              @click.stop="sendTypification(item.id, true)"
            >
              Tipificar
            </v-btn>
            <v-btn
              small
              rounded
              color="primary"
              class="mb-2"
              @click.stop="sendTypification(item.id)"
            >
              No Tipificar
            </v-btn>
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at) }}
          </template>

          <template v-slot:[`item.campaign_id`]="{ item }">
            <v-chip
              v-if="item.campaign_id != null"
              color="transparent"
              small
              @click="OpenDetailsVar1(item)"
            >
              {{ getVariable1(item.campaign_id) }}
            </v-chip>

            <!-- <v-chip v-else color="transparent" small>
              {{ item.variable_1 }}
            </v-chip> -->

            <div v-else>
              {{ item.campaign_id }}
            </div>
          </template>

          <template v-slot:[`item.type`]="{ item }">
            {{
              item.type === "E"
                ? "Entrada"
                : item.type === "W"
                ? "WhatsApp"
                : "Salida"
            }}
          </template>

          <template v-slot:expanded-item="{ item }">
            <td colspan="9">
              <v-row v-if="item.contact" class="pl-15 ml-10 pt-8 pb-5">
                <v-col cols="4" class="py-0">
                  <p class="info--text">
                    Nombre:
                    <span class="text--primary">{{ item.contact.name }}</span>
                  </p>
                </v-col>
                <v-col cols="4" class="py-0">
                  <p class="info--text">
                    Apellido:
                    <span class="text--primary">{{
                      item.contact.lastNAme
                    }}</span>
                  </p>
                </v-col>
                <v-col cols="4" class="py-0">
                  <p class="info--text">
                    Documento:
                    <span class="text--primary">
                      {{ item.contact.document }}
                    </span>
                  </p>
                </v-col>
                <v-col cols="4" class="py-0">
                  <p class="info--text">
                    Email:
                    <span class="text--primary">
                      <a
                        class="text--primary"
                        :href="`mailto:${item.contact.email}`"
                      >
                        {{ item.contact.email }}
                      </a>
                    </span>
                  </p>
                </v-col>
                <v-col cols="4" class="py-0">
                  <p class="info--text">
                    Bussiness:
                    <span class="text--primary">{{
                      item.contact.business
                    }}</span>
                  </p>
                </v-col>
                <v-col cols="4" class="py-0">
                  <p class="info--text">
                    Comentarios:
                    <span class="text--primary">{{
                      item.contact.comments
                    }}</span>
                  </p>
                </v-col>
              </v-row>
              <p v-else class="pl-15 ml-10">
                Datos de contacto no disponibles.
              </p>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <detailsVar1
      v-if="isOpenDetailsVar1"
      :isActive="isOpenDetailsVar1"
      :data="dataVar1"
      @close:dialog="closeDetailsVar1"
    ></detailsVar1>

    <typification-form
      v-if="formDialog"
      :dialog="formDialog"
      @close:dialog="closeDialog"
      :temporaryTableId="temporaryTableId"
      :isEditMode="false"
      :queueNumber="queueNumberSelected"
      :requestOptions="options"
    />
  </section>
</template>

<script>
import axios from "axios";
import moment from "moment";
import TypificationForm from "./TypificationForm.vue";
import detailsVar1 from "./detailsVar1.vue";

export default {
  components: { TypificationForm, detailsVar1 },

  data() {
    return {
      isLoading: true,
      isOpenDetailsVar1: false,
      formDialog: false,
      baseUrl: `${process.env.VUE_APP_URL_BASE}:8096`,
      temporaryTableId: null,
      queueNumberSelected: null,
      options: {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
      tableHeaders: [
        {
          text: "Extension",
          align: "left",
          value: "extension",
          width: "10%",
        },
        {
          text: "Numero",
          align: "left",
          value: "call_number",
          width: "10%",
        },
        {
          text: "Tipo",
          align: "left",
          value: "type",
          width: "10%",
        },
        {
          text: "Fecha",
          align: "left",
          value: "created_at",
          width: "15%",
        },
        {
          text: "Campañia",
          align: "left",
          value: "campaign_id",
          width: "10%",
        },
        {
          text: "Variable 1",
          align: "left",
          value: "variable_1",
          width: "10%",
        },
        {
          text: "Variable 2",
          align: "left",
          value: "variable_2",
          width: "10%",
        },
        {
          text: "Variable 3",
          align: "left",
          value: "variable_3",
          width: "10%",
        },
        {
          text: "Acciones",
          value: "action",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      tableData: [],
      dataVar1: [],
    };
  },

  created() {
    this.getInfo();
  },
  methods: {
    closeDialog(success = false) {
      this.formDialog = false;
      if (success) this.getInfo();
    },

    closeDetailsVar1() {
      this.isOpenDetailsVar1 = false;
    },
    getVariable1(item) {
      // const match = item.match(/campaing_id:([^}]+)/);
      // const valor = item;

      return item;
    },

    OpenDetailsVar1(item) {
      this.isOpenDetailsVar1 = true;
      this.dataVar1 = {
        campaign_id: item.campaign_id,
        call_number: item.call_number,
      };
      this.openFormDialog();
    },

    verifyVar1(item) {
      const var1 = item.campaign_id;

      if (var1 !== null) {
        return true;
      } else {
        return false;
      }
    },

    detailsVar1(item) {
      // const jsonObject = JSON.parse(item.variable_1);
      const var1 = item.variable_1;

      // var hasKey = Object.prototype.hasOwnProperty.call(
      //   jsonObject,
      //   "campaing_id"
      // );

      if (var1 !== null) {
        console.log("si");
      } else {
        return false;
      }

      // console.log(typeof jsonObject);
      // console.log(hasKey);
    },

    async sendTypification(id, send = false) {
      if (send) {
        this.temporaryTableId = id;
        this.queueNumberSelected = this.tableData.find(
          (el) => el.id === id
        )?.queue;
        this.formDialog = true;
        return;
      }
      try {
        await axios.post(
          `${process.env.VUE_APP_ROOTAPI}/typing/register_not_typing_call`,
          { temporaryTable_id: id },
          this.options
        );
        this.$snotify.success("La llamada ha sido guardada", "¡Hecho!");
      } catch (err) {
        this.$snotify.error(
          "Ha ocurrido un error guardando la llamada ",
          "Error"
        );
      }
      this.getInfo();
      this.isLoading = false;
    },
    async getInfo() {
      this.isLoading = true;
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_ROOTAPI}/typing/typing_call/get`,
          this.options
        );
        this.tableData = data.data;
        // console.log("data", data);
      } catch (err) {
        if (err.response.status === 401) {
          this.$snotify.error("Su sesion ha finalizado.", "Error");
          this.$store.dispatch("passport/RESET_AUTH");
          this.$router.push({ name: "login" });
          return;
        }
        // console.log("err", err);
      }
      this.isLoading = false;
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm");
    },
  },
};
</script>
